import { ContainerOptions } from "pixi.js";
import { JSX } from "react";

export type PixiContainerProps = Omit<Partial<ContainerOptions>, "children"> & {
  children?: JSX.Element | JSX.Element[] | null;
  label?: string;
};

export function WebGLContainer({
  children,
  label,
  ...props
}: PixiContainerProps) {
  return (
    <pixiContainer
      cullable={true}
      cullableChildren={true}
      label={label}
      {...props}
    >
      {children}
    </pixiContainer>
  );
}
